
import React, { useState, useRef, useEffect } from "react";
import { Modal, Form, Row, Col, Overlay, Popover, Button } from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchIndustryData, setSelectedIndustry } from "../../redux/actions/industryActions";
import { useDispatch, useSelector } from "react-redux";
import { fetchSkill, selectSkill } from "../../redux/actions/skillAction";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useParams } from "react-router-dom";
import axios from "../../API/axios";
import toast from "react-hot-toast";


const AddSkills = ({ show, handleClose, getUserCv, userDataId }) => {
    // console.log('experienceData', experienceData);
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();

    const [display, setDisplay] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisplay(true);
        const body = {
            sessionId: sessionId,
            userDataId: userDataId,
            userType: userType,
            instnCnddtID: CandidateId === 'null' ? null : CandidateId,
            skillName: skillName,
        };
        console.log("body", body);
        if (industryId === '' || skillName === '') {
            toast.error('Please fill all the required fields')
        } else {
            try {
                const res = await axios.post("/Resume/AddSkill", body);
                toast.success(res.data.message);
                // handleCloseExperienceRole();
                handleClose();
                getUserCv();
                setSkillName('')
                setIndustryId('')
                setSkillListId('')
                setDisplay(false)
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    toast.warning(error.response.data.message);
                } else {
                    toast.error(error.response?.data?.message || "An error occurred");
                }
            }
        }
    };
    // ..................................................................................
    const [showTooltip, setShowTooltip] = useState(false); // Manages tooltip visibility
    const [newSkill, setNewSkill] = useState(""); // Stores new skill input
    const targetRef = useRef(null); // Ref to anchor tooltip

    // Toggle tooltip visibility
    const toggleTooltip = () => {
        console.log("Toggling Tooltip");
        setShowTooltip((prev) => !prev);
    };
    console.log(targetRef.current);
    // Save the new skill
    const handleSaveSkill = () => {
        console.log("New Skill Created:", newSkill);
        setShowTooltip(false); // Close tooltip
        setNewSkill(""); // Reset input
        // Add logic to save skill (e.g., API call or state update)
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     // setDisplay(true);
    //     const body = {
    //         industry: industryId,
    //         skill: skillListId,
    //     }
    //     console.log("body", body);
    // }

    // ...............................Industry DDL.......................................
    const [displays, setDisplays] = useState(false)
    const [industryId, setIndustryId] = useState("");
    const dispatch = useDispatch();
    const { industryList, selectedIndustryId } = useSelector(
        (state) => state.industry
    );
    useEffect(() => {
        dispatch(fetchIndustryData());
    }, [dispatch]);


    const handleIndustrySelect = (val) => {
        //  dispatch(setSelectedIndustry(val.value));
        setIndustryId(val.value);
    };
    // ...............................Industry DDL.......................................

    // ...............................skill DDL.......................................
    const [skillListId, setSkillListId] = useState("");
    const [skillName, setSkillName] = useState("");
    const { skillList, selectedSkillId } = useSelector(
        (state) => state.skill

    );
    console.log("skillList", skillList);

    useEffect(() => {
        if (industryId) {
            dispatch(fetchSkill(industryId)); // Pass industryId to the action
        }
    }, [dispatch, industryId]);

    const handleSkillSelect = (selectedOption) => {
        if (selectedOption) {
            //   dispatch(selectSkill(selectedOption.value));
            setSkillListId(selectedOption.value);
            setSkillName(selectedOption.label)
        }
    };
    // ...............................skill DDL.......................................



    return (
        <Modal show={show} onHide={handleClose} centered size="md">
            <Modal.Header >
                <Modal.Title>Add Skills</Modal.Title>
                <CloseSharpIcon className="pointer" onClick={handleClose} />
            </Modal.Header>
            <Modal.Body className="settings">
                <Row>
                    {/* Industry Selection */}
                    <Col md={12}>
                        <Form.Group controlId="Industry">
                            <Form.Label className="class-type">
                                Industry
                                <span style={{ color: "red" }} className="ms-2">
                                    *
                                </span>
                            </Form.Label>
                        </Form.Group>

                        <div className="post-form-group">
                            <ReactSelect
                                options={industryList}
                                onChange={handleIndustrySelect}
                                value={
                                    industryList.find(
                                        (option) => option.value === industryId
                                    ) || null
                                }
                                placeholder="Select Industry"
                                classNamePrefix="react-select"
                                className="form-control"
                                styles={customStyles}
                            />
                            {display && !industryId ? <span className='error_msg_lbl text-red'>Select Industry</span> : null}

                        </div>
                    </Col>

                    {/* Skills Section */}
                    <Col md={12}>
                        <Form.Group controlId="Skills">
                            <Form.Label className="class-type">
                                Skills
                                <span style={{ color: "red" }} className="ms-2">
                                    *
                                </span>
                            </Form.Label>
                        </Form.Group>

                        <div className="post-form-group mb-0">
                            <ReactSelect

                                options={skillList}
                                onChange={handleSkillSelect}
                                value={
                                    skillList.find(
                                        (option) => option.value === skillListId
                                    ) || null
                                }
                                placeholder="Select Skills"
                                classNamePrefix="react-select"
                                className="form-control"
                                styles={customStyles}
                            // isDisabled={!selectedIndustryId} // Disable until industry is selected

                            />
                            {display && !skillListId ? <span className='error_msg_lbl text-red'>Select Skill</span> : null}

                        </div>

                        {/* Create New Link */}
                        {/* {industryId &&
                            <a
                                href="#"
                                ref={targetRef}
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleTooltip();
                                }}
                                className="createModal"
                                isDisabled={!industryId} // Disable until industry is selected
                            >
                                Create New
                            </a>
                        }
                        <Overlay
                            target={targetRef.current}
                            show={showTooltip}
                            placement="right"
                            rootClose
                            container={document.querySelector('.modal')}
                            onHide={() => setShowTooltip(false)} // Close when clicking outside
                        >
                            <Popover id="popover-basic">
                                <Popover.Header as="h3">Create New Skill</Popover.Header>
                                <Popover.Body>
                                    <Form>
                                        <input
                                            type="text"
                                            value={newSkill}
                                            onChange={(e) => setNewSkill(e.target.value)}
                                            placeholder="Enter new skill"
                                            className="mb-3"
                                        />
                                        <div className="d-flex justify-content-end">
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={handleSaveSkill}
                                                className="me-2"
                                            >
                                                Save
                                            </Button>
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() => setShowTooltip(false)}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </Form>
                                </Popover.Body>
                            </Popover>
                        </Overlay> */}
                    </Col>
                </Row>

                {/* Submit Button */}
                <div className="add-class-submit-button mt-4 d-flex justify-content-center">
                    <div className="khojPrimaryBtn ms-3">
                        <a href="#/" className="" onClick={handleSubmit}>
                            Submit
                        </a>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddSkills;
